import { render, staticRenderFns } from "./AccountDialog.vue?vue&type=template&id=bcef9c7e&scoped=true"
import script from "./AccountDialog.vue?vue&type=script&lang=js"
export * from "./AccountDialog.vue?vue&type=script&lang=js"
import style0 from "./AccountDialog.vue?vue&type=style&index=0&id=bcef9c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcef9c7e",
  null
  
)

export default component.exports